import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'

export const HomePageContainer = styled.div`
  width: 100vw;
  padding: 10px 20px;

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    padding: 0px 50px;
  }
`
export const HomeRowSection = styled.div`
  display: flex;
  gap: 25px;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: 30px;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    flex-direction: column;
  }
`
export const HomeColumnSection = styled.div`
  min-width: 340px;
  width: 50%;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    width: 100%;
  }
`

export const PageTitle = styled.h1`
  ${DefaultFontStyle};
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #0b0a0a;
  margin-block-start: 0px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 34px;
  }
`

export const SubHeader = styled.h3`
  ${DefaultFontStyle};
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: ${props => props.theme.colours.charcoal};
  margin-block-start: 25px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 21px;
    line-height: 32px;
    margin-block-start: 22px;
  }
`
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  height: 300px;
  position: relative;
  z-index: 2;
  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    height: 150px;
    position: relative;
    z-index: 2;
  }
`

export const FieldLabel = styled.label`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  margin: 30px 0 10px;

  @media only screen and (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 18px;
    display: flex;
    flex-direction: row;
  }
`

export const LocationIcon = styled.img`
  width: 20px;
`

export const ErrorMessage = styled.div`
  ${DefaultFontStyle};
  color: #d82036;
  display: block;
  font-size: smaller;
  padding-right: 20px;
  text-align: left;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 10px;
    top: 200px;
  }
`

export const ErrorIcon = styled.img`
  width: 20px;
  margin-left: 5px;
  margin-top: -2px;
  position: relative;
  margin-right: 5px;
`
